<div (keydown.enter)="submit()" class="flex flex-col gap-6">

  <section class="flex flex-col gap-4">
    <elcia-label [label]="'app.general' | translate"/>

    <div class="flex gap-2">
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameFr" [label]="'product.name-fr' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameNl" [label]="'product.name-nl' | translate"/>
      </div>
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.nameEn" [label]="'product.name-en' | translate"/>
      </div>
    </div>

    @if (initialValue()) {
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.guid" [label]="'product.guid' | translate"/>
      </div>
    }

  </section>

</div>
